function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.0146 7.59484C18.0146 10.6542 15.5616 13.1074 12.5 13.1074C9.4395 13.1074 6.98545 10.6542 6.98545 7.59484C6.98545 4.53544 9.4395 2.08333 12.5 2.08333C15.5616 2.08333 18.0146 4.53544 18.0146 7.59484ZM12.5 22.9167C7.98166 22.9167 4.16669 22.1823 4.16669 19.3489C4.16669 16.5145 8.00563 15.8062 12.5 15.8062C17.0194 15.8062 20.8334 16.5406 20.8334 19.3739C20.8334 22.2083 16.9944 22.9167 12.5 22.9167Z",
  fill: "white"
});
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.b7670921517abb156d22822dfa30c1eb.svg";
export { ForwardRef as ReactComponent };